/** Renk yardımcıları (WCAG 2.x göreli parlaklık ve kontrast oranı). Girdi her zaman `#rrggbb`. */

export const HEX_RE = /^#[0-9a-f]{6}$/i;

function channels(hex: string): [number, number, number] {
  const n = Number.parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function toHex([r, g, b]: [number, number, number]): string {
  return `#${[r, g, b]
    .map((c) =>
      Math.round(Math.min(255, Math.max(0, c)))
        .toString(16)
        .padStart(2, '0'),
    )
    .join('')}`;
}

export function luminance(hex: string): number {
  const [r, g, b] = channels(hex).map((c) => {
    const s = c / 255;
    return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  }) as [number, number, number];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** Kontrast oranı (1–21). */
export function contrast(a: string, b: string): number {
  const la = luminance(a);
  const lb = luminance(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}

/** `a` ile `b` arasında karışım: t=0 → a, t=1 → b. */
export function mix(a: string, b: string, t: number): string {
  const ca = channels(a);
  const cb = channels(b);
  return toHex([0, 1, 2].map((i) => ca[i]! + (cb[i]! - ca[i]!) * t) as [number, number, number]);
}

/**
 * Bir zemin üzerinde okunacak yazı rengi: beyaz yeterliyse beyaz, değilse koyu gri, o da yetmezse siyah.
 * Herhangi bir zemin için beyaz veya siyahtan biri her zaman en az 4,58:1 verir.
 */
export function readableOn(background: string, min = 4.5): string {
  for (const c of ['#ffffff', '#16211d', '#000000']) if (contrast(c, background) >= min) return c;
  return contrast('#ffffff', background) >= contrast('#000000', background) ? '#ffffff' : '#000000';
}

export function roundRatio(r: number): number {
  return Math.floor(r * 100) / 100;
}
